module.exports = __webpack_public_path__ + "static/media/irritated-annoyed.75e4117f.png";